import React, {Component} from 'react';
import Auxiliar from '../Auxiliar/Auxiliar';    
import classes from './Layout.css';
import Toolbar from '../../components/Navigation/Toolbar/Toolbar';
import SideDrawer from '../../components/Navigation/SideDrawer/SideDrawer';
class Layout extends Component {
    state ={
        showSideDrawer: false
    }
    sideDrawerCloseHander = ()=>{
        this.setState({showSideDrawer:false});
    }

    sideDrawerToggleHandler = ()=>{
        this.setState((prevState)=>{
           return  {showSideDrawer: !prevState.showSideDrawer};
        });
    }

    render(){
        return(
            <Auxiliar>
            <Toolbar drawerToggleClicked={this.sideDrawerToggleHandler}/>
            <SideDrawer open={this.state.showSideDrawer} closed={this.sideDrawerCloseHander}/>
            <main className={classes.Content}>
                {this.props.children}
            </main>
            </Auxiliar>
        );

    }


}

export default Layout;


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js